import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});


const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '650x' : '700px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textC = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '15px': isMobileBig ? '50px': isMiniNotebook ? '50x' : '55px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divC = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '400px': isMobileBig ? '400px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '400px' : '450px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

const imageB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '240px': isMobileMedium ? '380px': isMobileBig ? '360px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '300px' : '320px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

const imageC = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '220px': isMobileMedium ? '300px': isMobileBig ? '270px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '270px' : '270px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})


const linkA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
}: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
}) => ({
  color: '#fff', // Azul padrão para links
  textDecoration: 'none', // Remove sublinhado padrão
  fontSize: isMobileMini ? '13px' : isMobileMedium ? '14px' : isMobileBig ? '16px' : isMiniNotebook ? '18px' : '18px',
  width: isMobileMini ? '150px' : isMobileMedium ? '160px' : isMobileBig ? '175px' : isMiniNotebook ? '220px' : '250px',
  display: "inline-block",
  padding: "10px 15px",
  backgroundColor: "#007bff", // Cor de botão (altere conforme necessário)
  borderRadius: "5px",
  textAlign: "center",
  fontWeight: "bold",
  transition: "background-color 0.3s",
  margin: "0 auto",
  
  ':hover': {
    color: '#0056b3', // Azul mais escuro no hover
    textDecoration: 'underline',
  },
  
  ':active': {
    color: '#004494', // Azul ainda mais escuro no clique
  }
});


export const card_24_01_25 = {

  date: '24-01-2025',
  routeCard: '/nutricao/top-3-marcas-creatina/24-01-2025',
  description: 'Creatina, melhores marcas, preços baixos',
  month: 'Janeiro',
  shortTitle: 'Creatina: Melhores marcas, preços baixos ',
  elements: [
    {
      type: 'title',
      content: 'Creatina: Top 3 marcas para construir seus músculos',
      getStyles: titleA,
    },
    {
      type: 'div',
      content: [
    {
            type: 'image',
            content: cardImages.CreatineProteinFormula_24_01_25,
            getStyles: imageA,
          },
        
        ],
        getStyles: divA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          Na categoria dos suplementos, a creatina ocupa posição essencial no aumento da massa muscular,
          performance física e força. Ela é muito utilizada por atletas e fisiculturistas que buscam aumento muscular.
         Ela nada mais é um conjunto de aminoácidos (glicina, metionina e arginina) que são essenciais na construção dos músculos.</p>
         
          <p style="text-indent: 20px;">        Embora o organismo produza estes nutrientes de forma natural. Aqueles que trabalham os músculos vigorosamente necessitam de uma boa fonte extra. 
         Uma forma natural de obtê-los é através da ingestão de carnes e especialmente o peixe. 
         </p>
          <br></br>
          `,
          getStyles: textA,
        },
        {
          type: 'image',
          content: cardImages.CreatineProteinMuscle_24_01_25,
          getStyles: imageA,
        },
      ],
      getStyles: divA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          O ideal é que a suplementação esteja aliada a uma alimentação equilibrada e completa, com uma boa rotina de exercícios e repouso. Isso porque, com a ausência de uma prática regular causa um efeito de inchaço no corpo. 
         </p>
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    {
          type: 'title',
          content: 'Top 3 Creatina do Mercado',
          getStyles: titleA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Max Titanium Creatina',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              O Max Titanium Creatina da marca Max Titanium é um produto top de linha no ramo de suplementos. 
              Para aqueles que buscam a hipertrofia. Uma cretina 100% pura, sem adiçoes, sem açúcar nem carboidratos. 
              Não contem glutem. São 300 gramas de um produto com alto teor de aminoácidos e que vai alavancar muito os resultados do teu treino.   
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/4aZ67xS',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.CreatinaMax_24_01_25,
            getStyles: imageB,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Integralmedica - Creatina em Pó Hardcore 100% Pura e Monohidratada',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              A creatina da marca integralmedica é a preferida dos atletas que buscam aumento muscular em pouco tempo. 
              Uma creatina 100% pura e monohidratada. Sua otima solubilidade e boa digestão, evita que se formem aqueles pequenos grumos. 
              Vem na quantidade de 300 gramas. Uma otima opção para quem busca uma boa praticidade, valor nutricional e ótimos resultados.   
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/3QdZNsB',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.CreatinaIntegralMedica_24_01_25,
            getStyles: imageB,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Creatina Pura Monohidratada Dark Lab',
          getStyles: titleA,
        },
        {
        type: 'div',
        content: [
          {
          type: 'div',
          content: [
            {
              type: 'text',
             content: `
              <p style="text-indent: 20px;">
              A creatina da Dark Lab é uma otima escolha para aqueles que buscam uma melhor performance atlética a atividades de alta intensidade. 
              Um produto 100% creatina, livre de adiçoes e carboidratos. Vem na quantidade de 300gramas.   
             </p>
              `,
              getStyles: textC,
            },
            {
              type: 'text',
              content: `
               <p style="text-indent: 20px;">
               Garanta já com um desconto, basta acessar o link:  
              </p>
               `,
               getStyles: textC, 
            },
            {
              type: 'link',
              content: 'https://amzn.to/3EtTI8I',
              label: "Desconto Amazon",
              getStyles: linkA,
            },
            {
              type: 'br',
              content: '',
              getStyles: brA,
            },
          ],
          getStyles: divC,
          },
          {
            type: 'image',
            content: cardImages.CreatinaDarkLab_24_01_25,
            getStyles: imageC,
          },
        ],
        getStyles: divA,
        },
      ],
      getStyles: divB,
    },
    
  ] as ElementType[],
  tags: ['nutrição', 'creatina', 'suplemento', 'promoção'],
  author: 'John Doe',
}

